export default "__VITE_ASSET__6159525a__"